const templateRe = /\{ *([\w_-]+) *\}/g;

// @function template(str: String, data: Object): String
// Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
// and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
// `('Hello foo, bar')`. You can also specify functions instead of strings for
// data values — they will be evaluated passing `data` as an argument.
export function template(str, data) {
  return str.replace(templateRe, function(str, key) {
    let value = data[key];

    if (value === undefined) {
      throw new Error("No value provided for variable " + str);
    } else if (typeof value === "function") {
      value = value(data);
    }
    return value;
  });
}

const charToInt = (c) => {
  switch (c) {
    case "I":
      return 1;
    case "V":
      return 5;
    case "X":
      return 10;
    case "L":
      return 50;
    case "C":
      return 100;
    case "D":
      return 500;
    case "M":
      return 1000;
    default:
      return -1;
  }
};

export const romanToInt = (str1) => {
  if (str1 === null) return -1;
  let num = charToInt(str1.charAt(0));
  let pre, curr;

  for (let i = 1; i < str1.length; i++) {
    curr = charToInt(str1.charAt(i));
    pre = charToInt(str1.charAt(i - 1));
    if (curr <= pre) {
      num += curr;
    } else {
      num = num - pre * 2 + curr;
    }
  }

  return num;
};

/**
 *
 * @param {Apt} apt
 */
export const getLoadTitle = (apt) => {
  if (apt.isOverLoaded()) {
    return this.getI18n().__(
      "The locker is very saturated, there may be no free compartment when sending parcels, delivery is expected to be 2-3 days late."
    );
  }
  if (apt.isMediumLoaded()) {
    return this.getI18n().__(
      "The locker is moderately saturated, in case of parcel delivery there may be no free slot, the delivery delay is expected on average 1 day."
    );
  }
  return this.getI18n().__(
    "The locker is not saturated, parcel delivery is uninterrupted, there is no delivery delay."
  );
};

export const handleListView = (e) => {
  let mapContainer = $(".map-container");
  let aptListContainer = $("#apt-list");
  let mapDisplay = $("#map");
  let restrictedListContainer = $("#apt-list-restricted");

  if (e.type === "click") {
    if (mapContainer.is(":visible") && restrictedListContainer.is(":visible")) {
      restrictedListContainer.hide();
      setMapContainerHeight();
    }
    mapContainer.toggle();
    aptListContainer.toggle();
    mapDisplay.toggle();
  }
  let mapViewString =
    '<span class="svg-icon map-marker"></span><span id="toggle-inner-text">Váltás térképes nézetre</span>';
  let listViewString =
    '<span class="svg-icon list"></span><span id="toggle-inner-text">Váltás lista nézetre</span>';
  if (mapContainer.is(":visible")) {
    $("#viewToggle").html(listViewString);
    $(document).trigger("view:map");
  } else {
    $("#viewToggle").html(mapViewString);
  }
};
export const isNonstop = (openingHours) => {
  let values = Object.values(openingHours);
  let nonstop = values.filter((v) => v === "00:00-24:00");
  return values.length === nonstop.length;
};

export const postSelectedApm = (apm) => {
  window.top.postMessage(JSON.stringify(apm), "*");
};
export const setRestrictedListHeight = () => {
  let el = $("#apt-list-restricted");
  if (el.is(":visible") && el.children("li").length > 3) {
    el.css("max-height", () => {
      let h = 0;
      el.children("li").each((ind, el) => {
        if (ind < 3) {
          h += $(el).outerHeight();
        }
      });
      return h;
    });
  }
};
/** @deprecated */
export const setMapContainerHeight = () => {
  return;
  const el = $("#apt-list-restricted");
  const filterRow = $("#filter-options");
  const map = $("div.content")[0];
  const mobileRow = $("div.mobile-fill-row")[0];
  const title = $("p.subtitle")[0];
  let offset = 55;
  let additionalHeightValues = 0;
  additionalHeightValues += $(title).outerHeight();
  if ($(mobileRow).is(":visible")) {
    additionalHeightValues += $(mobileRow).outerHeight();
    offset = 0;
  }
  if ($(filterRow).is(":visible")) {
    additionalHeightValues += filterRow.outerHeight();
    offset = -25;
  }
  if (el.is(":visible")) {
    const h =
      $($(".search-box")[0]).outerHeight() +
      el.outerHeight() +
      $($(".notation")[0]).outerHeight() +
      additionalHeightValues;
    $(map).height(` calc(100vh - ${h + offset}px`);
  } else {
    const h =
      $($(".search-box")[0]).outerHeight() +
      $($(".notation")[0]).outerHeight() +
      additionalHeightValues;
    $(map).height(` calc(100vh - ${h + offset}px`);
  }
};

export const setPaperBoxHeight = () => {
  const paper = document.getElementById("filterPanel");

  paper.style.height = "5vh";
};
export const setTextBoxes = () => {
  $("#apt-list-filter-paper-box").on("input", function() {
    $("#apt-list-filter").val($(this).val());
  });

  $("#apt-list-filter").on("input", function() {
    $("#apt-list-filter-paper-box").val($(this).val());
  });
};

export const getMarkerUrl = () => {
  let hasC2cParam = window.location.search.includes("c2c");
  let hasZboxParam = window.location.search.includes("show_prod_zboxes");
  let lang = $('html').attr('lang')
  let url = ""
  let attr = {'lang':lang}
  if(hasC2cParam)
    attr['c2c'] = 1;
  if(hasZboxParam){
    attr['show_prod_zboxes'] = 1
  }
    url = `markers.php?${$.param(attr)}`
    return url
};
export const setListTotal = (text) => {
  $(".listTotalCount").text(text);
};
export const getApmIcon = (apm) => {
  let icon = null;
  if (apm.variant) {
    switch (apm.variant) {
      case "FOXPOST":
        icon =
          "overloaded" === apm.load
            ? "marker-over-loaded"
            : "medium loaded" === apm.load
            ? "marker-medium-loaded"
            : "marker-normal-loaded";
        break;
      case "Packeta Z-Pont":
        icon = "marker-z-point";
        break;
      case "Packeta Z-BOX":
        icon = "marker-z-box";
        break;
    }
  } else {
    icon =
      "overloaded" === apm.load
        ? "marker-over-loaded"
        : "medium loaded" === apm.load
        ? "marker-medium-loaded"
        : "marker-normal-loaded";
  }
  return icon;
};
